import React, { useContext } from 'react'
import cn from 'classnames'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { MenuIcon, Bar } from '../../styles/2025/Styles'
import { ThemeContext } from '../../context/2025/ThemeContext'
import LayeredToggle from './LayeredToggle'

export const HamburgerMenu = ({ isOpenMenuNavs, toggleMobileNavs, className = '' }) => {
  const history = useHistory()
  const { pathname } = useLocation()
  const { isDarkMode } = useContext(ThemeContext)

  const navigate = (url) => {
    toggleMobileNavs()
    history.push(url)
  }

  const isActive = (url) => {
    return pathname === url
  }

  const menuItemClass = (url) =>
    cn({
      // Base styles
      'h4-mobile transition-colors duration-300 wavy-underline-hover': true,

      // Non-active state styles based on theme
      'text-white': isDarkMode && !isActive(url),
      'text-black': !isDarkMode && !isActive(url),

      // Active state - apply with higher specificity
      'text-lime !text-lime wavy-underline wavy-border-lime': isDarkMode && isActive(url),
      'text-lavender !text-lavender wavy-underline wavy-border-lavender':
        !isDarkMode && isActive(url),
    })

  const menuClasses = cn(
    'transition-all transition-height duration-500 pr-8 pt-8 cursor-pointer',
    {
      '-translate-x-[102vw] opacity-100 h-[100vh] !overflow-hidden': isOpenMenuNavs, // Menu slides in to natural position from right
      'translate-x-full opacity-90 h-[0vh]': !isOpenMenuNavs, // Menu slides out to the right
      'bg-black': isDarkMode,
      'bg-white': !isDarkMode,
    },
    className,
  )

  return (
    <div className={cn('relative flex justify-between mb-0 z-50 w-full', className)}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '170px',
          justifyContent: 'space-between',
        }}
      >
        {isDarkMode ? (
          <>
            <MenuIcon isOpen={isOpenMenuNavs} onClick={toggleMobileNavs}>
              <Bar className='bg-lime' isOpen={isOpenMenuNavs} />
              <Bar className='bg-lime' isOpen={isOpenMenuNavs} />
              <Bar className='bg-lime' isOpen={isOpenMenuNavs} />
            </MenuIcon>
            <Link to='/search'>
              <svg
                width='26'
                height='26'
                viewBox='0 0 26 26'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                className='hover:scale-[1.04] transition-transform duration-300'
              >
                <g id='Frame 76'>
                  <path
                    id='Vector'
                    d='M0.93934 22.9393C0.353553 23.5251 0.353553 24.4749 0.93934 25.0607C1.52513 25.6464 2.47487 25.6464 3.06066 25.0607L0.93934 22.9393ZM22.5 9.7C22.5 13.1242 19.7242 15.9 16.3 15.9V18.9C21.381 18.9 25.5 14.781 25.5 9.7H22.5ZM16.3 15.9C12.8758 15.9 10.1 13.1242 10.1 9.7H7.1C7.1 14.781 11.219 18.9 16.3 18.9V15.9ZM10.1 9.7C10.1 6.27584 12.8758 3.5 16.3 3.5V0.5C11.219 0.5 7.1 4.61898 7.1 9.7H10.1ZM16.3 3.5C19.7242 3.5 22.5 6.27583 22.5 9.7H25.5C25.5 4.61898 21.381 0.5 16.3 0.5V3.5ZM3.06066 25.0607L7.56066 20.5607L5.43934 18.4393L0.93934 22.9393L3.06066 25.0607ZM7.56066 20.5607L12.0607 16.0607L9.93934 13.9393L5.43934 18.4393L7.56066 20.5607Z'
                    fill='#DAFF01'
                  />
                </g>
              </svg>
            </Link>
          </>
        ) : (
          <>
            <MenuIcon isOpen={isOpenMenuNavs} onClick={toggleMobileNavs}>
              <Bar className='bg-black' isOpen={isOpenMenuNavs} />
              <Bar className='bg-black' isOpen={isOpenMenuNavs} />
              <Bar className='bg-black' isOpen={isOpenMenuNavs} />
            </MenuIcon>
            <Link to='/search'>
              <svg
                width='26'
                height='26'
                viewBox='0 0 26 26'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                className='hover:scale-[1.04] transition-transform duration-300'
              >
                <g id='Frame 76'>
                  <path
                    id='Vector'
                    d='M0.93934 22.9393C0.353553 23.5251 0.353553 24.4749 0.93934 25.0607C1.52513 25.6464 2.47487 25.6464 3.06066 25.0607L0.93934 22.9393ZM22.5 9.7C22.5 13.1242 19.7242 15.9 16.3 15.9V18.9C21.381 18.9 25.5 14.781 25.5 9.7H22.5ZM16.3 15.9C12.8758 15.9 10.1 13.1242 10.1 9.7H7.1C7.1 14.781 11.219 18.9 16.3 18.9V15.9ZM10.1 9.7C10.1 6.27584 12.8758 3.5 16.3 3.5V0.5C11.219 0.5 7.1 4.61898 7.1 9.7H10.1ZM16.3 3.5C19.7242 3.5 22.5 6.27583 22.5 9.7H25.5C25.5 4.61898 21.381 0.5 16.3 0.5V3.5ZM3.06066 25.0607L7.56066 20.5607L5.43934 18.4393L0.93934 22.9393L3.06066 25.0607ZM7.56066 20.5607L12.0607 16.0607L9.93934 13.9393L5.43934 18.4393L7.56066 20.5607Z'
                    fill='#000000'
                  />
                </g>
              </svg>
            </Link>
          </>
        )}

        <LayeredToggle />
        <div
          className={menuClasses}
          style={{ position: 'absolute', width: '101vw', left: 190, top: 42, paddingLeft: '24px' }}
        >
          <ul className='flex flex-col gap-16 text-center'>
            <li onClick={() => navigate('/home')} className='cursor-pointer text-center'>
              <h4 className={menuItemClass('/home')}>Home</h4>
            </li>
            <li onClick={() => navigate('/work')}>
              <h4 className={menuItemClass('/work')}>Work</h4>
            </li>
            <li onClick={() => navigate('/grads')}>
              <h4 className={menuItemClass('/grads')}>Graduates</h4>
            </li>
            <li onClick={() => navigate('/events')}>
              <h4 className={menuItemClass('/events')}>Events</h4>
            </li>
            <li onClick={() => navigate('/about')}>
              <h4 className={menuItemClass('/about')}>About</h4>
            </li>
            <li onClick={() => navigate('/awards')}>
              <h4 className={menuItemClass('/awards')}>Awards</h4>
            </li>
            <li onClick={() => navigate('/letterbox')}>
              <h4 className={menuItemClass('/letterbox')}>Letterbox</h4>
            </li>
            <li onClick={() => navigate('/committee')}>
              <h4 className={menuItemClass('/committee')}>Committee</h4>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}
